import React from 'react';
import express from '../../assets/skill/express.png';
import firebase from '../../assets/skill/firebase.png';
import graphql from '../../assets/skill/GraphQl.png';
import js from '../../assets/skill/js.jpeg';
import mongo from '../../assets/skill/mongodb.png';
import mysql from '../../assets/skill/mysql.png';
import node from '../../assets/skill/node.png';
import postgres from '../../assets/skill/postgres.png';
import reactLogo from '../../assets/skill/react.png';
import redux from '../../assets/skill/redux.png';
import ts from '../../assets/skill/ts.png';

import mui from '../../assets/skill/mui.png';
import prisma from '../../assets/skill/prisma.svg';
import sequelize from '../../assets/skill/sequelize.png';
import tailwind from '../../assets/skill/tailwindcss.png';

const techIcons = [
    { src: js, alt: "JavaScript" },
    { src: ts, alt: "TypeScript" },
    { src: reactLogo, alt: "React" },
    { src: redux, alt: "Redux" },
    { src: node, alt: "Node.js" },
    { src: express, alt: "Express.js" },
    { src: mongo, alt: "MongoDB" },
    { src: mysql, alt: "MySQL" },
    { src: firebase, alt: "Firebase" },
    { src: postgres, alt: "PostgreSQL" },
    { src: graphql, alt: "GraphQL" },
    { src: prisma, alt: "Prisma" },
    { src: sequelize, alt: "Sequelize" },
    { src: tailwind, alt: "Tailwind CSS" },
    { src: mui, alt: "Material-UI" },
];

const Skills = () => {
    return (
        <>
            <br />
            <h2><span className='text-blue-500'>S</span>kills</h2>
            <hr />
            <br />
            <div className="flex flex-wrap justify-center  items-center space-x-4 space-y-4 md:space-y-0">
                <div className="flex flex-wrap justify-center gap-4">
                    {techIcons.map((icon, index) => (
                        <div key={index} className="relative group inline-block">
                            <div className="h-16 w-16 p-2 border-2 border-blue-400 rounded-full overflow-hidden transition-transform duration-300 ease-in-out transform hover:scale-110 hover:shadow-lg">
                                <img
                                    src={icon.src}
                                    alt={icon.alt}
                                    className="h-full w-full object-contain"
                                />
                            </div>
                            <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-full bg-gray-700 text-white text-xs rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                {icon.alt}
                            </span>
                        </div>
                    ))}
                </div>



            </div>
            <br />

        </>
    );
};

export default Skills;